import { SagaIterator } from 'redux-saga'
import { put, takeLatest, select, all } from 'redux-saga/effects'

import * as muteVideoActions from '../actions/muteVideo'
import { accountSelectors } from '../../account'

function* onRemoteVideoMuted({
  payload: [{ value: userId }],
}: ReturnType<typeof muteVideoActions.onRemoteVideoMuted>): SagaIterator {
  const currentUserId: ReturnType<typeof accountSelectors.getCurrentUserId> = yield select(
    accountSelectors.getCurrentUserId
  )

  if (currentUserId === parseInt(userId, 10)) {
    yield put(muteVideoActions.muteVideo())
  }
}

function* onVideoMuted(): SagaIterator {
  yield put(muteVideoActions.onMuteVideoProgressStateUpdate(false))
}

function* muteVideo(): SagaIterator {
  yield put(muteVideoActions.onMuteVideoProgressStateUpdate(true))
}

function* muteAudioSaga() {
  yield all([
    takeLatest(muteVideoActions.onRemoteVideoMuted, onRemoteVideoMuted),
    takeLatest(muteVideoActions.onVideoMuted, onVideoMuted),
    takeLatest(muteVideoActions.muteVideo, muteVideo),
  ])
}

export default muteAudioSaga
